<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import Avatar, { type AvatarProps } from "#lib/components/Avatar.svelte";
	import DataToken from "#lib/components/DataToken.svelte";
	import { TokenProvider } from "#lib/tokenProvider.js";

	type Props = {
		provider?: TokenProvider;
		mode: Mode;
		badgeClass?: string;
		avatarClass?: string;
		class?: string;
	} & AvatarProps;

	const { provider = new TokenProvider(), mode, src, class: className, badgeClass, avatarClass, ...other }: Props = $props();
</script>

<div class={className}>
	{#if mode === Mode.EDITING}
		<Avatar {src} {...other} class={avatarClass} />
		{#if src && provider.getSubstitutionToken(src)}
			{@const token = provider.getSubstitutionToken(src)}
			<div class="absolute right-1/2 bottom-2 translate-x-1/2 -translate-y-1/2">
				<DataToken provider={token?.provider} label={token?.label ?? ""} class={twMerge("pointer-events-none mr-0", badgeClass)} />
			</div>
		{/if}
	{:else}
		<Avatar {src} {...other} class={avatarClass} />
	{/if}
</div>
